import { type Quote } from "../types/Generic.types";

const LESS_THAN_ZERO: string = "0.01";
const ZERO: string = "0.00";

const currencyMap: Record<Quote, string> = {
    USD: "$",
    CAD: "CA$",
    EUR: "€",
    SGD: "S$",
    INR: "₹",
    JPY: "¥",
    VND: "₫",
    CNY: "CN¥",
    KRW: "₩",
    RUB: "₽",
    TRY: "₺",
    NGN: "₦",
    ARS: "ARS",
    AUD: "A$",
    CHF: "CHF",
    GBP: "£",
};

export const prettifyCurrency = (
    value: number | bigint | string,
    decimals = 2,
    currency: Quote = "USD",
    ignoreSmallValue = false,
    ignoreMinus = true,
    ignoreZero = false
): string => {
    let numValue = Number(value);
    let minus = "";
    let currencySuffix = "";

    if (!ignoreMinus && numValue < 0) {
        numValue = Math.abs(numValue);
        minus = "-";
    }

    const currencySymbol = currencyMap[currency] ?? "$";

    if (numValue === 0 || isNaN(numValue)) {
        return ignoreZero
            ? `<${currencySymbol}${LESS_THAN_ZERO}`
            : `${currencySymbol}${ZERO}`;
    }

    if (numValue < 0.01 && ignoreSmallValue) {
        return `<${currencySymbol}${LESS_THAN_ZERO}`;
    }

    if (numValue > 999999999) {
        numValue /= 1000000000;
        currencySuffix = "B";
    } else if (numValue > 999999) {
        numValue /= 1000000;
        currencySuffix = "M";
    }

    const factor = Math.pow(10, decimals);
    numValue = Math.floor(numValue * factor) / factor;

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        maximumFractionDigits: decimals,
        currencyDisplay: "symbol",
    });

    const formattedValue = formatter
        .format(numValue)
        .replace(new RegExp(`${currency}\\s?`), currencySymbol);

    return minus + formattedValue + currencySuffix;
};
